import { Component, OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { TournamentsService } from "src/app/services/tournamnet.service";
import { CommonService } from "src/app/services/common.service";
import { LazyLoadEvent } from "primeng/api";
import { CategoryService } from "../../services/category.service";
import { SubscribeService } from "src/app/frontend/service/subscribeService.service";

import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
import { RoleService } from "src/app/services/role.service";
@Component({
  selector: "app-leaderboard-result",
  templateUrl: "./leaderboard.component.html",
  styleUrls: ["./leaderboard.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class LeaderboardComponent implements OnInit {
  filtervisible: boolean = false;
  public tournamentId;
  public loggedInAcademy;
  public loggedInAcademyId;
  public isTournamentDrawView: boolean = false;
  public categoryId;
  public ageGroupId;
  public categoryList: any = [];
  public ageGroupList: any = [];
  public catList: any = [];
  public ageList: any = [];
  public selectedCatId;
  public selectedGroupId;
  categoryForm: FormGroup;
  public selectedAgeGroupId;
  public tournamentCategoryId;
  public publishStatus: boolean = true;
  public showPublish: boolean = false;
  public tournamentResult;
  public showEmpty: boolean = false;
  tournamentname: any;
  errorMessage = "";
  totalRecords: 0;
  loading: boolean;
  paginationOption;
  item: any;
  countrylist: any = [];
  citylist: any = [];
  statelist: any = [];
  countryCode = "IN";
  countryName = "India";
  countrycode: any;
  countryname: any;
  statecode: any;
  statename: any;
  citycode: any;
  cityname: any;
  public courtTypeList = environment.courtTypeList;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  courttype: any;
  tournamentList: any;
  playerName: string;
  selectedCountryOption: any;
  selectedStateOption: any;
  selectedCityOption: any;
  matchAgeQuery;
  tournamentCategory = [];
  removeCity = ["Navi Mumbai", "Thane", "Mumbai Suburban"];
  currentDate: Date;
  oneYearAgo: number;
  categoryAndAgeGroupListData: any[] = [];
  categoryAndAgeGroupList: any[] = [];
  searchedCategoryName: string | null = null;
  selectedCategoryName: string | null = null;
  statelistData: any[] = [];
  cityListData: any[] = [];
  searchedStateName: string = null;
  searchedCityName: string = null;
  selectedState: any = [];
  selectedCity: any = [];
  mobilFilter: boolean = false;
  position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
  public downloadModal: boolean = false;
  public yearlist = [];
  selectedYear: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private tokenStorageService: TokenStorageService,
    private tournamentService: TournamentsService,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private commonService: CommonService,
    private router: Router,
    private tournamentsService: TournamentsService,
    private categoryService: CategoryService,
    private subscribeService: SubscribeService,
    private roleService: RoleService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    var currentYear = new Date().getFullYear();
    for (let i = currentYear; i <= 2040; i++) {
      this.yearlist.push({ label: i, value: i });
    }
    // this.currentDate = new Date();
    // const oneYearAgo = new Date();
    // this.oneYearAgo  =oneYearAgo.setFullYear(this.currentDate.getFullYear() - 1);
    this.renderer.addClass(document.body, 'leaderboardPage');
    this.currentDate = new Date();
    this.currentDate.setDate(this.currentDate.getDate() - 1); 
    const oneYearAgo = new Date(this.currentDate);
    this.oneYearAgo = oneYearAgo.setFullYear(this.currentDate.getFullYear() - 1);

    this.roleService.setCurrentActiveRoute(this.router.url);
    this.tournamentId = this.activatedRoute.snapshot.paramMap.get("id");
    this.loggedInAcademy = this.tokenStorageService.getUser();
    this.paginationOption = environment.pagination;
    this.categoryForm = this.formBuilder.group({
      categoryType: ["", [Validators.required]],
      ageGroup: ["", [Validators.required]],
    });
    let category = this.tournamentService.getCategory();
    if (category != "") {
      this.categoryId = category["categoryId"];
      this.ageGroupId = category["ageGroupId"];
      this.showPublish = true;
    }
    this.getCountry();
    this.getState(this.countryCode);
    // this.getTournamentsLocation();
   // this.getState();
    // this.getTournamentCategories();
    this.getTournamentCategoriesV2();
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'leaderboardPage');
  }

  // getTournamentsLocation() {
  //   this.tournamentsService.getTournamentsLocations().subscribe((res) => {
  //     this.statelistData = JSON.parse(JSON.stringify(res.data.statelist));
  //     this.statelist = this.statelistData;
  //     this.cityListData = JSON.parse(JSON.stringify(res.data.citylist));
  //     this.citylist = this.cityListData;
  //   });
  // }

  onSearchState(event) {
    this.statelist = this.statelistData.filter(ele => (ele.name) ? ele.name.toLowerCase().includes(event.target.value.toLowerCase()) : null);
  }

  onSearchCity(event) {
    this.citylist = this.cityListData.filter(ele => (ele.name) ? ele.name.toLowerCase().includes(event.target.value.toLowerCase()) : null);
  }

  async getTournamentCategory(event) {
    if (event.value != null) {
      this.tournamentId = event.value.id;
      let query = "getMatchtype=true";
      this.tournamentService
        .getTournamentCategory(this.tournamentId, query)
        .subscribe(
          (data) => {
            if (data) {
              this.categoryList = data.items;
              this.categoryList.forEach((element) => {
                if (element.matchTypeId === this.categoryId) {
                  this.categoryForm.controls.categoryType.setValue(element);
                  let event = {
                    value: {
                      matchTypeId: element.matchTypeId,
                    },
                  };
                  this.onSelectCategory(event);
                }
              });
            }
          },
          (err) => { }
        );
    } else {
      this.tournamentId = "";
      this.selectedGroupId = "";
      this.categoryList = [];
      this.ageGroupList = [];
      this.selectedAgeGroupId = "";
    }
  }

  onSelectCategory(event) {
    if (event.value != null) {
      this.selectedGroupId = event.value.matchTypeId;
      let query = "getAgeGroup=true&matchtype=" + event.value.matchTypeId;
      this.showEmpty = true;
      //this.categoryId='';
      this.tournamentService
        .getTournamentCategory(this.tournamentId, query)
        .subscribe(
          (data) => {
            this.ageGroupList = [];
            this.publishStatus = true;
            if (data) {
              this.ageGroupList = data.items;
              this.ageGroupList.forEach((element) => {
                if (element.ageGroupId === this.ageGroupId) {
                  this.categoryForm.controls.ageGroup.setValue(element);
                  this.publishStatus = element.publishStatus;
                  this.tournamentCategoryId = element.tournamentCategoryId;
                }
              });
            }
          },
          (err) => { }
        );
    } else {
      this.selectedGroupId = "";
      this.ageGroupList = [];
      this.selectedAgeGroupId = null;
    }
  }
  onAgeGroupSelect(event) {
    this.selectedStateOption = null;
    this.selectedCityOption = null;
    this.statecode = null;
    this.statename = "";
    this.citylist = [];
    this.citycode = null;
    if (event.value != null) {
      this.selectedAgeGroupId = event.value.value;
      if (event.value.drawStatus && !event.value.publishStatus) {
        this.showPublish = true;
      } else {
        this.showPublish = false;
      }
      this.publishStatus = event.value.publishStatus;
      this.tournamentCategoryId = event.value.tournamentCategoryId;
      this.tournamentResult = [];
    } else {
      this.selectedAgeGroupId = null
    }
    let query = "&filterByMatchId=" + this.selectedCatId + "&filterByAgegroupId=" + this.selectedAgeGroupId;
    this.subscribeService.fetchPlayerRakingDetails(query);
    this.loadLeaderboard(this.lastTableLazyLoadEvent);
  }

  loadLeaderboard(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;

    let query = "filterByDisable=false&filterByPublishStatus=true";
    let pagenumber = 1;
    let params = "";
    let rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    if (this.selectedCatId != null && this.selectedAgeGroupId != null) {
      params += "&filterByMatchId=" + this.selectedCatId;
      params += "&filterByAgegroupId=" + this.selectedAgeGroupId;
      if (this.countrycode != null) {
        params += "&filterByCountrycode=" + this.countrycode;
      }
      if (this.citycode != null) {
        params += "&filterByCitycode=" + this.citycode;
      }
      if (event.filters.global != undefined) {
        params += "&filterByPlayerNameFilter=" + event.filters.global.value;
      }
      if (this.statecode != null) {
        params += "&filterByStatecode=" + this.statecode;
      }
      if (this.selectedYear != null) {
        params += "&filterByYear=" + this.selectedYear;
      }
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }

      this.tournamentService.tournamentscore(query).subscribe((data) => {
        window.scroll(0, 0);
        this.tournamentResult = data["data"]["items"];
        this.totalRecords = data["data"]["totalCount"];
        if (this.tournamentResult.length > 0) {
          this.showEmpty = false;
          let index = 1;
          const rating = this.tournamentResult.forEach((player) => {
            const playerRating = player.playerRating;
            const oldplayerLastRating = player.oldplayerLastRating;
            if (playerRating > oldplayerLastRating) {
              let addition = playerRating - oldplayerLastRating;
              player.difference = addition;
              player.showclass = true;
            } else {
              let subtraction = playerRating - oldplayerLastRating;
              player.difference = subtraction;
              player.showclass = false;
            }
            player.serial = index++;
          });
        }
      });
    } else {
      this.tournamentResult = undefined;
      this.totalRecords = undefined;
    }
  }

   getCountry() {
    this.commonService.getCountryList().subscribe((res) => {
      this.countrylist = res.data.items;
    });
  }
  // getState() {
  //   this.commonService.getStateList(this.countryCode).subscribe((res) => {
  //     this.statelist = res.data.items;
  //   });
  // }

    onCountrySelect(event) {

    if (event.value != null) {
      this.countrycode = event.value.code;
      this.countryname = event.value.name;
      this.getState(this.countrycode);
    } else {
      this.countrycode = null;
      this.countryname = "";
      this.statelist = [];
      this.statecode = null;
    }
    this.loadLeaderboard(this.lastTableLazyLoadEvent);
  }

  onStateSelect(event) {
    if (Object.keys(event).length !== 0) {
      this.statecode = event.code;
      this.statename = event.name;
      this.getCity(this.statecode);
    } else {
      this.statecode = null;
      this.statename = "";
      this.citylist = [];
      this.citycode = null;
    }
    this.loadLeaderboard(this.lastTableLazyLoadEvent);
  }

    findSelectedIndexByStatename(statename, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].name === statename) {
        index = i;
        break;
      }
    }
    return index;
  }

  findSelectedIndexByCityname(cityname, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].name === cityname) {
        index = i;
        break;
      }
    }
    return index;
  }
  getCity(statecode) {
    this.commonService.getCityList(statecode).subscribe(
      (data) => {
        // this.citylist = data.data.items;
        this.cityListData = JSON.parse(JSON.stringify(data.data.items));
        this.citylist = this.cityListData;
        this.removeCity.forEach((cityname) => {
          let rIndex = this.findSelectedIndexByCityname(cityname, this.citylist);
          if (rIndex != -1) {
            this.citylist.splice(rIndex, 1);
          }
        });
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
    getState(countrycode) {
    this.commonService.getStateList(countrycode).subscribe(
      (data) => {
        // this.statelist = data.data.items;
        this.statelistData = JSON.parse(JSON.stringify(data.data.items));
        this.statelist = this.statelistData;
        this.removeCity.forEach((statename) => {
          let rIndex = this.findSelectedIndexByStatename(statename, this.statelist);
          if (rIndex != -1) {
            this.statelist.splice(rIndex, 1);
          }
        });
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  onCitySelect(event) {
    if (Object.keys(event).length !== 0) {
      this.citycode = event.code;
      this.cityname = event.name;
    } else {
      this.citycode = "";
      this.cityname = "";
    }
    this.loadLeaderboard(this.lastTableLazyLoadEvent);
  }

  onYearChange(event) {
    if (event.value !== null) {
      this.selectedYear = event.value;
    } else {
      this.selectedYear = null;
    }
    this.loadLeaderboard(this.lastTableLazyLoadEvent);
  }

  filterDialog() {
    this.filtervisible = true;
  }

  getTournamentCategories() {
    // let query =
    //   "?filterByDisable=false&filterByStatus=true&filterBySlug=tournament_category";
    // this.categoryService.getCategoryWithoutAuthList(query).subscribe((data) => {
    //   var query =
    //     "?filterByDisable=false&filterByStatus=true&filterByParent=" +
    //     data.data.items[0]["id"] +
    //     "&sortBy=created_at&orderBy=1";
    //   this.categoryService
    //     .getCategoryDetailsWithoutAuthList(query)
    //     .subscribe((data) => {
    //       var catlist = data.data.items;
    //       catlist.forEach((element) => {
    //         let obj = {
    //           label: element.name,
    //           value: element.id,
    //           slug: element.slug,
    //         };
    //         this.catList.push(obj);
    //       });
    //     });
    // });    
    this.tournamentService.gettournamentLeaderCategory().subscribe((data) => {
      //console.log(data['items']);
      this.tournamentCategory = data['items'];
      var catlist = data['items'];
      catlist.forEach((element) => {
        let obj = {
          label: element.matchName[0].name,
          value: element.matchName[0]._id,
          slug: element.matchName[0].slug,
          sequence: element.matchName[0].sequence,
        };
        this.catList.push(obj);
      });
      this.catList.sort((a, b) => a.sequence - b.sequence);
    });
  }

  getTournamentCategoriesV2() {
    this.tournamentService.gettournamentLeaderCategoryV2().subscribe((data) => {
      this.categoryAndAgeGroupListData = JSON.parse(JSON.stringify(data['items']));
      this.categoryAndAgeGroupList = this.categoryAndAgeGroupListData;
    });
  }

  onSearchCategory(event) {
    this.categoryAndAgeGroupList = this.categoryAndAgeGroupListData.filter(ele => (ele.categoryName) ? ele.categoryName.toLowerCase().includes(event.target.value.toLowerCase()) : null);
  }

  onselectGetCategory(event) {
    this.selectedCountryOption = null;
    this.selectedStateOption = null;
    this.selectedCityOption = null;
    this.statecode = null;
    this.statename = "";
    this.citylist = [];
    this.citycode = null;
    this.ageList = [];
    this.categoryForm.controls.ageGroup.reset();
    if (event.value != null) {
      this.selectedCatId = event.value.value;
      let index = this.findIndexById(this.selectedCatId, this.tournamentCategory);
      let agegrouplist = this.tournamentCategory[index];
      agegrouplist['ageGroupData'].sort((a, b) => a.sequence - b.sequence);
      //agegrouplist
      this.ageList = [];
      agegrouplist['ageGroupData'].forEach((element) => {
        console.log(element);
        let obj = {
          label: element.name,
          value: element._id,
          slug: element.slug,
        };
        this.ageList.push(obj);
      });
    } else {
      this.ageList = [];
      this.selectedCatId = null;

    }
    //this.loadLeaderboard(this.lastTableLazyLoadEvent);
    this.tournamentResult = [];


  }

  onselectGetCategoryV2(event) {
    let matchTypeId = (event.value !== null && event.value !== undefined) ? event.value.matchTypeId : event.matchTypeId;
    let ageGroupId = (event.value !== null && event.value !== undefined) ? event.value.ageGroupId : event.ageGroupId;
    let query = "&filterByMatchId=" + matchTypeId + "&filterByAgegroupId=" + ageGroupId;
    this.subscribeService.fetchPlayerRakingDetails(query);
    this.selectedCatId = matchTypeId;
    this.selectedAgeGroupId = ageGroupId;
    this.loadLeaderboard(this.lastTableLazyLoadEvent);
  }

  findIndexById(id, array) {
    let index = -1;
    for (let i = 0; i < array.length; i++) {
      console.log(array[i]['_id']['matchTypeId'] + "  " + id);
      if (array[i]['_id']['matchTypeId'] === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  showUserdetails(userId) {
    //this.router.navigate(['/player-details/' + userId], { queryParams: { filterByMatchId: this.selectedCatId, filterByAgegroupId: this.selectedAgeGroupId}});
    this.router.navigate(['/player-details/' + userId], { queryParams: { userProfile: false } });
  }

  showUserProfile(userId) {
    //this.router.navigate(['/player-details/' + userId], { queryParams: { filterByMatchId: this.selectedCatId, filterByAgegroupId: this.selectedAgeGroupId}});
    let query = "";
    this.subscribeService.fetchPlayerRakingDetails(query);
    this.router.navigate(['/player-details/' + userId], { queryParams: { userProfile: true } });
  }

  onDownloadClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright'){
    this.position = position;
    this.downloadModal = true; 
  }

  showMobileFilter() {
    this.mobilFilter = true;
  }

  clear() {
    this.selectedState = null;
    this.statecode = null;
    this.statename = null;
    this.selectedCity = null;
    this.citycode = null;
    this.cityname = null;
    this.cityListData = [];
    this.citylist = [];
    this.selectedCategoryName = null;
    this.selectedCatId = null;
    this.selectedAgeGroupId = null;
    this.selectedYear = null;
    this.loadLeaderboard(this.lastTableLazyLoadEvent);
    const obj = {
      target: {
        value: ''
      }
    }
    
    this.onSearchCategory(obj);
    this.searchedCategoryName = null;
    this.onSearchState(obj);
    this.searchedStateName = null;
    this.onSearchCity(obj);
    this.searchedCityName = null;
  }
}
